import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

export const getDossiersForContact = (
  contactId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossiers", contactId],
    queryFn: (): Promise<Dossier[]> => {
      return fetchWithAuth<Dossier[]>("getDossiersForContact", contactId);
    },
    enabled: isQueryEnabled(options),
  });
};
